module.exports = __webpack_public_path__ + "a06958d66e1dd7e8e35f1885698ee4b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_kathleen_mobile.jpg
// module id = 671
// module chunks = 0